var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgOfficesIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 4.5H16.5C18.1575 4.5 19.5 5.8425 19.5 7.5V14.607C19.5 16.2645 18.1575 17.607 16.5 17.607H7.5C5.8425 17.607 4.5 16.2645 4.5 14.607V7.5C4.5 5.8425 5.8425 4.5 7.5 4.5Z",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 17.607H27.1815C25.524 17.607 24.1815 16.2645 24.1815 14.607V7.5C24.1815 5.8425 25.524 4.5 27.1815 4.5H31.5",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 31.5V25.5C4.5 23.8425 5.8425 22.5 7.5 22.5H16.5C18.1575 22.5 19.5 23.8425 19.5 25.5V31.5",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31.5V25.5C24 23.8425 25.3425 22.5 27 22.5H31.5",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOfficesIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/OfficesIcon.34ad5797.svg";
export { ForwardRef as ReactComponent };